import React from "react";
import "./RegistrationForm.scss";
import { Link, withRouter } from "react-router-dom";
import { compose } from "recompose";

import Input from "components/Input";
import Button from "components/Button";
import Thumbnail from "components/Thumbnail";

import * as ROUTES from "constants/routes";
import { withFirebase } from "components/Firebase";

const INITIAL_STATE = {
  form: {
    email: "",
    password: "",
    error: null
  }
};

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  handleInputChange = e => {
    const { form } = this.state;
    const { id, value } = e.target;

    form[id] = value;

    this.setState({ form });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { email, password } = this.state.form;
    this.props.firebase
      .doCreateUserWithEmailAndPassword(email, password)
      .then(authUser => {
        return this.props.firebase.user(authUser.user.uid).set({ email });
      })
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.ONBOARDING);
      })
      .catch(error => {
        this.setState({ error });
      });
  };

  handleGoogleSignUp = e => {
    e.preventDefault();
    console.log("Google button was pressed.");
    this.props.firebase
      .doCreateUserWithGoogleAccount()
      .then(response => {
        console.log(response);

        const {
          email,
          family_name,
          given_name,
          picture
        } = response.additionalUserInfo.profile;

        if (response.additionalUserInfo.isNewUser) {
          this.props.firebase.user(response.user.uid).set({
            email: email,
            firstName: given_name,
            lastName: family_name,
            picture
          });
          this.setState({ ...INITIAL_STATE });
          this.props.history.push(ROUTES.ONBOARDING);
        } else {
          this.props.history.push(`/profile/${response.user.uid}`);
        }
      })

      .catch(error => {
        this.setState({ error });
      });
  };
  render() {
    const { onlyForm } = this.props;
    const { error } = this.state;
    const { email, password } = this.state.form;
    return (
      <div className="RegistrationForm">
        <div>
          <div className="content">
            <h3>Create account</h3>
            <form onSubmit={this.handleSubmit} action="">
              <div className="fields">
                <Input
                  onChange={this.handleInputChange}
                  autoFocus
                  required
                  name="email"
                  label="Email"
                  value={email}
                  type="email"
                  placeholder="Enter your email address"
                />
                <Input
                  onChange={this.handleInputChange}
                  name="password"
                  required
                  label="Password"
                  value={password}
                  type="password"
                  placeholder="Enter your password"
                />
              </div>
              {error && <p className="error">{error.message}</p>}
              <div className="buttons">
                <Button type="primary">Create account</Button>
                <Button onClick={this.handleGoogleSignUp} type="google">
                  Sign up with Google
                </Button>
              </div>
            </form>
          </div>
          {onlyForm ? null : (
            <div className="footer">
              {/* <a href="#">Forgot password?</a> */}
              <span>
                Have an account? <Link to={ROUTES.SIGN_IN}>Sign in</Link>
              </span>
            </div>
          )}
        </div>

        {onlyForm ? null : (
          <div className="WhySignUp">
            <Thumbnail
              // height={"100%"}
              image="https://mir-s3-cdn-cf.behance.net/project_modules/fs/9d06d676909513.5c77b32d97931.jpg"
            />
            {/* WhySignUp */}
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  withRouter,
  withFirebase
)(RegistrationForm);
